import React from 'react';

const Kbd = ({ children, textColor = 'text-content-primary', textSize = 'text-xs', borderColor = 'border-border' }) => (
  <kbd className={`-mb-0.5 px-2 py-1 ${textSize} font-semibold ${textColor} bg-background-white rounded-md border ${borderColor} shadow-sm`}>{children}</kbd>
);

export default Kbd;
